import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AuthService } from "../../authentication/auth.service";
import { ApiServiceBase } from "../../base/api-service-base";
import { OrganisationTypeReferenceModel } from "../../models/organisation-model";

@Injectable({
    providedIn: 'root'
})
export class OrganisationTypeReferenceService extends ApiServiceBase {
    private readonly ORGANISATION_PATH = "/organisation"
    constructor( 
        private httpClient: HttpClient,
        private authService: AuthService
    ) {
        super(httpClient, authService);
    }

    public searchOrganisationType(organisationTypeCode: string): Observable<OrganisationTypeReferenceModel[]> {
        let params = new HttpParams()
          .set("code", organisationTypeCode);
    
        return this.httpGet<any>(this.ORGANISATION_PATH + "/organisationTypeReference", params)
          .pipe(
            map(response => {
              return response.body;
            })
          );
    }
}
